/**
 * Assert payment request DTO
 */
export class AssertPaymentRequestDto {
	/**
	 * The ID of the payment to assert.
	 */
	paymentId!: number;

	/**
	 * Optional provider token (e.g. Saferpay paymentPageToken from redirect URL).
	 * Use when the token is not stored on the payment (e.g. Secure PayGate flow).
	 */
	providerToken?: string;
}
